import link from "@/scripts/host.js";
import loggedIn from '@/scripts/logged.js'


export default {
  name: "SearchBar",
  props: ["modal"],
  data() {
    return {
      loginOptions: false,
      size: 's',
      hamburgerMenu: false,
      showTooltip: false,
      hover: false
    };
  },
  computed:{
    isLogged(){
      return this.$store.state.loggedIn;
    },
    searchActive() {
      return this.$store.state.searchActive;
    },
    username() {

      if (sessionStorage.getItem('user')) {
        return JSON.parse(sessionStorage.getItem('user')).login
      } else if (localStorage.getItem('user')) {
        JSON.parse(localStorage.getItem('user')).login
      } else {
        return ''
      }
      
    },
    shortUsername() {
    
      if (sessionStorage.getItem('user')) {
        return JSON.parse(sessionStorage.getItem('user')).login.length > 8 ? JSON.parse(sessionStorage.getItem('user')).login.slice(0,8) + '...' : JSON.parse(sessionStorage.getItem('user')).login
      }
      else if (localStorage.getItem('user')) {
       return JSON.parse(localStorage.getItem('user')).login.length > 8 ? JSON.parse(localStorage.getItem('user')).login.slice(0,8) + '...' : JSON.parse(localStorage.getItem('user')).login
      } else {
        return ''
      }
    },
    email() {
  
      if (sessionStorage.getItem('user')) {
        JSON.parse(sessionStorage.getItem('user')).email
      }   else if (localStorage.getItem('user')) {

      return JSON.parse(localStorage.getItem('user')).email
    } else {
      return ''
    }
  }
  },
  methods: {
    openModal() {
      if (localStorage.getItem('user') !== null || sessionStorage.getItem('user') !== null) {
        this.loginOptions = !this.loginOptions;
        this.searchActive = false;
      } else {
        this.$store.dispatch("setModalType", "login");
        this.$store.dispatch("toggleLoginModal");
      }
    },
    async logOut() {
      let token = await loggedIn();

      this.showTooltip = false;
      this.axios({
        method: "post",
        url: `${link.hostLink}Account/Logout`,
        headers: {authorization: `bearer ${token}`}
      })
        .then(function() {
          localStorage.removeItem('user');
          sessionStorage.removeItem('user');
        }).catch(function() {
          localStorage.removeItem('user');
          sessionStorage.removeItem('user');
        });
        this.$store.dispatch('setLogInFlag', false);
    },
    changePass() {
      this.$store.dispatch("setModalType", "changePass");
      this.$store.dispatch("toggleLoginModal");
      this.loginOptions = !this.loginOptions;

    },
    changeMail() {
      this.$store.dispatch("setModalType", "changeMail");
      this.$store.dispatch("toggleLoginModal");
      this.loginOptions = !this.loginOptions;

    },
    deleteAcc() {
      this.$store.dispatch("setModalType", "deleteAcc");
      this.$store.dispatch("toggleLoginModal");
      this.loginOptions = !this.loginOptions;

    },
    editProfile() {
      if(!this.isLogged) {
        this.openModal()
      } else {
      this.$store.dispatch("setModalType", "editProfile");
      this.$store.dispatch("toggleLoginModal");
      this.loginOptions = !this.loginOptions;
      }
    },
    
    onToggle() {
      this.hamburgerMenu = !this.hamburgerMenu;
    },
    checkLogged() {
      return JSON.parse(localStorage.getItem('user'));
    },
    toggleSearch() {
      this.$store.dispatch("toggleSearch");
      this.loginOptions = false;
    },
    closeSearchBar() {
      this.$store.dispatch("toggleSearch");
    },
    closeFallMenu() {
      this.loginOptions = false;
    },
    onClickAway() {
      if (this.searchActive) {
        this.closeSearchBar();
      }
    },
   
    
  },

  mounted() {
    if(localStorage.user || sessionStorage.user) {
      this.$store.dispatch('setLogInFlag', true);
    }
    if(this.$store.state.searchQuery && this.$route.path === '/wyszukaj') {
      this.searchActive = true;
    }
  }
}
